
import BaseComponent from "../base-component.js";
import DrawingEditor from "../../../drawing-editor/index.js"
import rubricReport from "./rubric-report.jsx";
import { h } from "preact"
import FeedbackContainer from "./feedback-container.jsx";

export default class DrawingReportComponent extends BaseComponent {
    componentDidMount() {
        let response = this.props.studentResponse;
        this.renderDrawingEditor(response)
        this.props.didRender();
    }

    componentWillUnmount() {
        if (!this._drawingEditor) { return };
        this._drawingEditor.destroy();
        this._drawingEditor = null;
    }

    /**
     * 
     * @param {import("../../shared-types").StudentResponse | undefined} response 
     */
    renderDrawingEditor(response) {
        let meta = this.props.item.responseDeclaration.meta
        var drawingEditorContainer;
        if (this.base instanceof HTMLElement) drawingEditorContainer = this.base.querySelector(".drawing-editor-container")
        if (!drawingEditorContainer) {
            throw ("Failed to find .drawing-editor-container")
        }

        this._drawingEditor = new DrawingEditor(drawingEditorContainer, {
            height: Number(meta.height),
            width: Number(meta.width),
            readOnly: true,
            enableSaveWorkflow: false,
            enableDrawingToggle: this.props.teacherResponse?.drawing_feedback?.url ? true : false,
        });

        this._drawingEditor.setBackgroundSrc(meta.drawing_src);

        let responseImage = response ? response.drawing?.image_url || response.drawing?.image_data : undefined;

        this._drawingEditor.setReadOnlyLayerSrc(responseImage);

        if (this.props.teacherResponse?.drawing_feedback?.url) {
            this._drawingEditor.fromDataURL(this.props.teacherResponse.drawing_feedback.url)
        }
    }

    responseCollector() {
        return (
            h("div", { class: "drawing-editor-container" })
        )
    }

    render() {
        return (
            this.wrapper(this.body(), this.responseCollector(), this.props.teacherResponse?.text_feedback ? <FeedbackContainer feedbackText={this.props.teacherResponse.text_feedback}/> : null, this.props.rubricReport ? rubricReport({rubricReport: this.props.rubricReport}) : null)
        );
    }
}